import { CommonModule } from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {MatDatepickerModule,MatFormFieldModule,MatInputModule} from '@angular/material';
import {MatMomentDateModule} from'@angular/material-moment-adapter';
import {CustomDatepickerComponent} from './custom-datepicker.component';
import {YearPickerComponent} from './year-picker-component/year-picker.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatMomentDateModule,
  ],
  declarations: [
    CustomDatepickerComponent,
  
    YearPickerComponent,
   
  ],
  exports: [
    CustomDatepickerComponent,
  ],
})
export class CustomDatepickerModule {}